import axios from "../axios-auth";
import orginal_axios from "axios";

export const netSaleReportService = {
    getNetSaleReportSummary,
    getSaleAmountDetail,
    getAllSaleAmountDetail,
    getSaleDiscountAmountDetail,
    getAllSaleDiscountAmountDetail,
    getSaleReturnAmountDetail,
    getAllSaleReturnAmountDetail,
    getSaleReturnDiscountAmountDetail,
    getAllSaleReturnDiscountAmountDetail,
    getSaleExpenseAmountDetail,
    getAllSaleExpenseAmountDetail,
    getAllSaleAmountDetailExport,
    getAllSaleDiscountAmountDetailExport,
    getAllSaleReturnAmountDetailExport,
    getAllSaleReturnDiscountAmountDetailExport,
    getAllSaleExpenseAmountDetailExport
};

function getNetSaleReportSummary(searchParams) {
    let params = {
    };
    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }
    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }
    if (searchParams.shopId) {
        params["shopId"] = searchParams.shopId;
    }
    return axios.get("/auth/net-sale-report-summary", { params });
}

function getSaleAmountDetail(searchParams, page, size, sortedBy) {

    if (!page) {
        page = 0;
    }
    else {
        page -= 1;
    }
    if (!size) {
        size = 50;
    }
    let params = {
        page: page,
        size: size,
        sort: sortedBy
    };

    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }
    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }
    if (searchParams.shopId) {
        params["shopId"] = searchParams.shopId;
    }
    return axios.get("/auth/sale-amount-detail", { params });
}

function getAllSaleAmountDetail(searchParams) {
    let params = {
    };
    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }
    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }
    if (searchParams.shopId) {
        params["shopId"] = searchParams.shopId;
    }
    return axios.get("/auth/sale-amount-detail", { params });
}

function getSaleDiscountAmountDetail(searchParams, page, size, sortedBy) {
    if (!page) {
        page = 0;
    }
    else {
        page -= 1;
    }
    if (!size) {
        size = 50;
    }
    let params = {
        page: page,
        size: size,
        sort: sortedBy
    };

    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }
    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }
    if (searchParams.shopId) {
        params["shopId"] = searchParams.shopId;
    }
    return axios.get("/auth/sale-discount-amount-detail", { params });
}

function getAllSaleDiscountAmountDetail(searchParams) {
    let params = {};
    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }
    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }
    if (searchParams.shopId) {
        params["shopId"] = searchParams.shopId;
    }
    return axios.get("/auth/sale-discount-amount-detail", { params });
}

function getSaleReturnAmountDetail(searchParams, page, size, sortedBy) {
    if (!page) {
        page = 0;
    }
    else {
        page -= 1;
    }
    if (!size) {
        size = 50;
    }
    let params = {
        page: page,
        size: size,
        sort: sortedBy
    };

    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }
    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }
    if (searchParams.shopId) {
        params["shopId"] = searchParams.shopId;
    }

    return axios.get("/auth/sale-return-amount-detail", { params });
}

function getAllSaleReturnAmountDetail(searchParams) {
    let params = {};

    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }
    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }
    if (searchParams.shopId) {
        params["shopId"] = searchParams.shopId;
    }
    return axios.get("/auth/sale-return-amount-detail", { params });
}

function getSaleReturnDiscountAmountDetail(searchParams, page, size, sortedBy) {
    if (!page) {
        page = 0;
    }
    else {
        page -= 1;
    }
    if (!size) {
        size = 50;
    }
    let params = {
        page: page,
        size: size,
        sort: sortedBy
    };

    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }
    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }
    if (searchParams.shopId) {
        params["shopId"] = searchParams.shopId;
    }

    return axios.get("/auth/sale-return-discount-amount-detail", { params });
}

function getAllSaleReturnDiscountAmountDetail(searchParams) {
    let params = {};

    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }
    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }
    if (searchParams.shopId) {
        params["shopId"] = searchParams.shopId;
    }
    return axios.get("/auth/sale-return-discount-amount-detail", { params });
}

function getSaleExpenseAmountDetail(searchParams, page, size, sortedBy) {
    if (!page) {
        page = 0;
    }
    else {
        page -= 1;
    }
    if (!size) {
        size = 50;
    }
    let params = {
        page: page,
        size: size,
        sort: sortedBy
    };

    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }
    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }
    if (searchParams.shopId) {
        params["shopId"] = searchParams.shopId;
    }

    return axios.get("/auth/sale-expense-amount-detail", { params });
}

function getAllSaleExpenseAmountDetail(searchParams) {
    let params = {};

    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }
    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }
    if (searchParams.shopId) {
        params["shopId"] = searchParams.shopId;
    }
    return axios.get("/auth/sale-expense-amount-detail", { params });
}

function getAllSaleAmountDetailExport(searchParams) {
    let params = {};
    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }
    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }
    if (searchParams.shopId) {
        params["shopId"] = searchParams.shopId;
    }
    return orginal_axios({
        method: "GET",
        url: axios.defaults.baseURL + "/auth/sale-amount-detail-export",
        params,
        responseType: "arraybuffer", // important
        headers: {
            Authorization: "Bearer " + localStorage.getItem("accessToken"),
            Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            "Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        }
    }).then(function (response) {
        return { blob: new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }), headers: response.headers }
    });
}

function getAllSaleDiscountAmountDetailExport(searchParams) {
    let params = {};

    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }
    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }
    if (searchParams.shopId) {
        params["shopId"] = searchParams.shopId;
    }
    return orginal_axios({
        method: "GET",
        url: axios.defaults.baseURL + "/auth/sale-discount-amount-detail-export",
        params,
        responseType: "arraybuffer", // important
        headers: {
            Authorization: "Bearer " + localStorage.getItem("accessToken"),
            Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            "Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        }
    }).then(function (response) {
        return { blob: new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }), headers: response.headers }
    });
}

function getAllSaleReturnAmountDetailExport(searchParams) {
    let params = {};

    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }
    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }
    if (searchParams.shopId) {
        params["shopId"] = searchParams.shopId;
    }
    return orginal_axios({
        method: "GET",
        url: axios.defaults.baseURL + "/auth/sale-return-amount-detail-export",
        params,
        responseType: "arraybuffer", // important
        headers: {
            Authorization: "Bearer " + localStorage.getItem("accessToken"),
            Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            "Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        }
    }).then(function (response) {
        return { blob: new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }), headers: response.headers }
    });
}

function getAllSaleReturnDiscountAmountDetailExport(searchParams) {
    let params = {};

    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }
    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }
    if (searchParams.shopId) {
        params["shopId"] = searchParams.shopId;
    }
    return orginal_axios({
        method: "GET",
        url: axios.defaults.baseURL + "/auth/sale-return-discount-amount-detail-export",
        params,
        responseType: "arraybuffer", // important
        headers: {
            Authorization: "Bearer " + localStorage.getItem("accessToken"),
            Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            "Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        }
    }).then(function (response) {
        return { blob: new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }), headers: response.headers }
    });
}

function getAllSaleExpenseAmountDetailExport(searchParams) {
    let params = {};

    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }
    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }
    if (searchParams.shopId) {
        params["shopId"] = searchParams.shopId;
    }
    return orginal_axios({
        method: "GET",
        url: axios.defaults.baseURL + "/auth/sale-expense-amount-detail-export",
        params,
        responseType: "arraybuffer", // important
        headers: {
            Authorization: "Bearer " + localStorage.getItem("accessToken"),
            Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            "Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        }
    }).then(function (response) {
        return { blob: new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }), headers: response.headers }
    });

}

